import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from 'components/ui/buttons/Button/index.js';
import { isPlainObject } from 'es-toolkit';

import {
  Paper,
  Wrapper,
} from './ErrorFallback.styled.js';

interface ErrorFallbackProps {
  error: unknown;
}

export const ErrorFallback = ({ error }: ErrorFallbackProps) => {
  const reloadHandler = () => window.location.reload();
  const returnHomeHandler = () => window.location.replace('/');

  return (
    <Wrapper>
      <Paper>
        <Typography color="error" variant="h5" align="center" gutterBottom data-sentry-unmask>
          Something Went Wrong:
        </Typography>
        <Box mt={2}>
          <Typography color="textSecondary" align="center">
            {(isPlainObject(error) && 'message' in error) ? error?.message as string : error?.toString()}
          </Typography>
        </Box>
        <Box mt={2} display="flex" justifyContent="center" data-sentry-unmask>
          <Button disableElevation onClick={reloadHandler}>
            Reload page
          </Button>
          <Box ml={2}>
            <Button disableElevation onClick={returnHomeHandler}>
              Return to Home page
            </Button>
          </Box>
        </Box>
      </Paper>
    </Wrapper>
  );
};
